import { render, staticRenderFns } from "./AdApproval.vue?vue&type=template&id=25826732&"
import script from "./AdApproval.vue?vue&type=script&lang=js&"
export * from "./AdApproval.vue?vue&type=script&lang=js&"
import style0 from "./AdApproval.vue?vue&type=style&index=0&id=25826732&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports